import { api, REFERENCE_API_SUB_URLS } from '@/api';
import { AxiosResponse } from 'axios';
import { Module } from 'vuex';
import {
  RootState,
  IrsContributionLimitsResponseModel,
  HealthPlansResponseModel,
} from '@/@types/member';

interface ReferenceState {
  irsLimits: IrsContributionLimitsResponseModel[];
  healthPlanOptions: HealthPlansResponseModel[];
}

const REFERENCE_STATE: Module<ReferenceState, RootState> = {
  state: {
    irsLimits: [],
    healthPlanOptions: [],
  },
  actions: {
    // UC-REST-001 - Get IRS Contribution Limits
    getIRSContributionLimits(context): Promise<AxiosResponse> {
      return api
        .get(
          `${REFERENCE_API_SUB_URLS.references}/irs-limits`,
        )
        .then((limits) => {
          context.commit('setIRSLimits', limits.data);
          return limits.data;
        });
    },
    // UC-REST-054 - Get Health Plan Options
    getHealthPlanOptions(context): Promise<AxiosResponse> {
      return api
        .get(
          `${REFERENCE_API_SUB_URLS.references}/health-plans`,
        )
        .then((healthPlans) => {
          context.commit('setHealthPlanOptions', healthPlans.data);
          return healthPlans.data;
        });
    },
  },
  mutations: {
    setIRSLimits(
      state: ReferenceState,
      data: IrsContributionLimitsResponseModel[],
    ): void {
      state.irsLimits = data;
    },
    setHealthPlanOptions(
      state: ReferenceState,
      data: HealthPlansResponseModel[],
    ): void {
      state.healthPlanOptions = data;
    },
  },
  getters: {
    irsLimits(state): IrsContributionLimitsResponseModel[] {
      return state.irsLimits;
    },
    healthPlanOptions(state): HealthPlansResponseModel[] {
      return state.healthPlanOptions;
    },
  },
};

export default REFERENCE_STATE;
